import { createSelector } from '@reduxjs/toolkit';

import { ReduxApplicationState } from '../combinedReducer';

export const selectSelectedZone = ({ deliveryZoneOptions }: ReduxApplicationState) =>
  deliveryZoneOptions.selectedZone;

export const selectSelectedCountry = ({ deliveryZoneOptions }: ReduxApplicationState) =>
  deliveryZoneOptions.selectedCountry;

export const selectDeliveryZoneOptions = ({ deliveryZoneOptions }: ReduxApplicationState) =>
  deliveryZoneOptions.options;

export const selectDeliveryZoneOptionsIsLoading = ({
  deliveryZoneOptions,
}: ReduxApplicationState) => deliveryZoneOptions.isLoading;

export const selectDeliveryOptionsForZone = createSelector(
  [selectSelectedZone, selectDeliveryZoneOptions],
  (selectedZone, options) =>
    options.find(({ zoneCode }) => zoneCode === selectedZone)?.deliveryOptions,
);
